import React, { useState } from "react";
import { OpenInNew } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { CustomButton } from "./customButton";
import { emitData, isEpicHttpUrl, openChatLink } from "../helpers/utils";
import { EVENTS } from "../events/botContants";

const useStyles = makeStyles(() => ({
  tierTwoButton: {
    border: "1px solid #C5C7C7 !important",
    "&:not(:first-child)": {
      borderTop: "none !important",
    },
    "&:first-child": {
      borderRadius: "8px 8px 0px 0px !important",
    },
    "&:last-child": {
      borderRadius: "0px 0px 8px 0px !important",
    },
    "&:only-child": {
      borderRadius: "8px 8px 8px 0px !important",
    },
  },
  single_button: {
    borderRadius: "8px 8px 8px 0px !important",
  },
  first_button: {
    borderRadius: "8px 8px 0px 0px !important",
  },
  middle_button: {
    borderRadius: "0px !important",
  },
  last_button: {
    borderRadius: "0px 0px 8px 0px !important",
  },
}));

export function TierTwoButton({
  actions,
  handleChipClick,
  isSignIn,
  minimizeBot,
  buttonClassName,
  variant,
  disabled = false,
  disableAfterClick = false,
}) {
  const classes = useStyles();
  const [hasSelection, setHasSelection] = useState(false);
  const isDisabled = disabled || hasSelection;

  const onClick = (action) => {
    if (isDisabled) {
      return;
    }

    if (disableAfterClick) {
      setHasSelection(true);
    }

    if (isSignIn) {
      emitData({ type: EVENTS.INITIATE_SIGNIN });
      minimizeBot();
    }
    if (action.url) {
      openChatLink(action.url);
      action.data = {
        linkSelected: `${action.title}`,
      };
      if (!isEpicHttpUrl(action.url)) {
        emitToMobile(action);
      }
    }
    handleChipClick(action);
  };

  const emitToMobile = (data) => {
    data = JSON.stringify(data);
    window.android?.openURL(data);
    window.webkit?.messageHandlers?.openURL?.postMessage(data);
  };

  const getBorderRadius = (actions, index) => {
    const singleButton = actions.length === 1;
    const firstButton = index === 0;
    const last_button = index === actions.length - 1;
    let borderRadius = classes.middle_button;
    if (singleButton) {
      borderRadius = classes.single_button;
    } else if (firstButton) {
      borderRadius = classes.first_button;
    } else if (last_button) {
      borderRadius = classes.last_button;
    }

    return [borderRadius, buttonClassName]
      .filter(Boolean)
      .join(" ");
  };

  return (
    <div>
      {actions?.map((action, index) => (
        <div
          key={action?.id ?? `${action?.title ?? "action"}-${index}`}
          className={classes.tierTwoButton}
        >
          <CustomButton
            onClick={() => onClick(action)}
            element={action}
            startIcon={
              action.url ? (
                <OpenInNew
                  style={{
                    color:
                      "var(--azure-chatbot-link-button-icon-color, var(--CUI2-neutral-on-surface-variant, #454747))",
                  }}
                />
              ) : undefined
            }
            className={getBorderRadius(actions, index)}
            variant={variant}
            disabled={isDisabled}
          />
        </div>
      ))}
    </div>
  );
}
